import { css } from 'linaria';

export const drawerAxisPoints = css`
  && {
    [data-testid="drawer-modal"] {
      @media (--only-mobile) {
        width: 100%;
      }
    }
  }
`;

export const drawerAxisPointsPreview = css`
  padding: 16px;
  display: flex;
  column-gap: 16px;
  border-radius: var(--rounding-l);
  background-color: var(--background-secondary);
  margin-bottom: 24px;
`;

export const drawerAxisPointsPreviewImage = css`
  width: 108px;
  height: 108px;

  @media (--only-mobile) {
    width: 74px;
    height: 74px;
  }
`;

export const drawerAxisPointsPreviewInfo = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  @media (--only-mobile) {
    align-content: space-around;
  }
`;

export const drawerAxisPointsButton = css`
  width: 100%;
`;